<template>
  <div style="height:100%">
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  computed: {
    ...mapGetters(['initialized']),
  },
  created () {
    this.initvuex()
    this.getcompanyname()
  },
  methods: {
    ...mapActions(['initstorage', 'setlogin']),
    initvuex () {
      if (!this.initialized) this.initstorage()
    },
    async getcompanyname () {
      try {
        const res = await this.$axios.companyname()
        document.title = res[0].companyname
      } catch (error) {
        console.error(error)
      }

    }
  }
}
</script>